import Fuse from 'fuse.js';
import _ from 'lodash';
import React, { useMemo, useState } from 'react';
import { Icon, SingleSelect, Tooltip } from '~/components';
import { colors } from '~/styles';

export default function OptionSelect({ defaultOptions, value, typeLabel, ...props }) {
  const [filterValue, setFilterValue] = useState('');

  const options = useMemo(() => {
    if (!filterValue) return defaultOptions;
    const fuse = new Fuse(defaultOptions, { keys: ['label', 'name'], threshold: 0.1 });
    return fuse.search(filterValue).map((r) => r.item);
  }, [defaultOptions, filterValue]);

  const selectedOption = useMemo(() => {
    if (!value) return null;
    const option = _.find(defaultOptions, { id: value });
    if (!option)
      return {
        id: value,
        name: (
          <Tooltip message={`${typeLabel} not found in Sage Intacct.`}>
            <Icon icon="warning" color={colors.warning} spaceRight />
            {typeLabel} ID: {value}
          </Tooltip>
        ),
      };
    return option;
  }, [defaultOptions, value, typeLabel]);

  return (
    <SingleSelect
      showEmptyOption
      showFilter
      value={value}
      valueRenderer={selectedOption?.label ?? selectedOption?.name ?? ''}
      onFilterChange={(event) => setFilterValue(event.target.value)}
      {...props}>
      {options?.map((option) => (
        // eslint-disable-next-line react/no-unknown-property
        <option key={option.id} value={option.id} tooltip={option.label ?? option.name}>
          {option.label ?? option.name}
        </option>
      ))}
    </SingleSelect>
  );
}
